import {
  faClone,
  faPencil,
  faTrash,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactModal from "react-modal";
import { useState } from "react";
import {
  COMPOSITION_OPTIONS,
  CompositionType,
} from "../mpn-composition-modal/AddMpnCompositionModal";
import {
  ICompositionComponent,
  ICompositionMpnComponent,
  IMpnComposition,
} from "../../../../types/data.interface";
import GenericConfirmationModal from "components/modals/GenericConfirmationModal";

const TreeActionsGroup = ({
  node,
  isMainPage,
  compositionType,
  addActionHandler,
  editActionHandler,
  removeActionHandler,
                            isMandatory
}: {
  node: IMpnComposition | ICompositionComponent;
  isMainPage: boolean;
  compositionType: CompositionType;
  addActionHandler: (...params: any) => void;
  editActionHandler: (
    compositionEditType: CompositionType,
    compositionEditObject: ICompositionComponent | IMpnComposition,
  ) => void;
  removeActionHandler: (
    node_id: number,
    compositionType: CompositionType,
  ) => void;
  isMandatory?: string | boolean;
}) => {
  const [showRemovalModal, setShowRemovalModal] = useState<boolean>(false);
  // const [quantity, setQuantity] = useState<number>(
  //   (node as ICompositionComponent).quantity ?? 1,
  // );

  const deleteNodeName =
    compositionType === COMPOSITION_OPTIONS.MPN
      ? `MPN ${(node as IMpnComposition).id} - ${(node as IMpnComposition).name}`
      : `Component ${(node as ICompositionMpnComponent)?.sequence_number ?? (node as ICompositionMpnComponent)?.mold_id} - ${(node as ICompositionMpnComponent).mold_description}`;

  // const quantityChangeHandler = (e: any) => {
  //   const cleanedNum = filterNonDigits(e.target.value);
  //   if (!isNaN(Number(cleanedNum)) && Number(cleanedNum) > 0) {
  //     changeNodeQuantity(Number(cleanedNum));
  //   }
  // };

  // const changeNodeQuantity = (newQuantity: number) => {
  //   if (newQuantity > 0) {
  //     setQuantity(newQuantity);
  //     addActionHandler(node.node_id, newQuantity);
  //   }
  // };

  const cancelDelete = () => {
    setShowRemovalModal(false);
  };

  return (
    <>
      <ReactModal
        isOpen={showRemovalModal}
        className="custom-modal"
        overlayClassName="custom-overlay"
        ariaHideApp={false} //FIXME: THIS IS TRIGGER A WARNING WITHOUT, NEED RESEARCH TO PROPERLY FIX IT.
      >
        <GenericConfirmationModal
          message={`You are going to remove the <strong>${deleteNodeName}</strong>, do you want to proceed?`}
          onCancel={cancelDelete}
          onConfirm={() => {
            removeActionHandler(node.node_id ?? -1, compositionType);
            setShowRemovalModal(false);
          }}
          cancelButtonMessage="Cancel"
          confirmButtonMessage="Yes and remove"
          icon={faWarning}
        />
      </ReactModal>

      <div
        className={`tree-actions-container d-flex gap-3 align-items-center align-self-start ${compositionType === COMPOSITION_OPTIONS.SKU ? "mt-1" : ""}`}
      >
        {/* {compositionType === COMPOSITION_OPTIONS.COMPONENT ? (
          <div className="col-md form-group mb-0 p-0 d-flex flex-column align-items-center">
            <label className="form-label mb-0" style={{ fontSize: "smaller" }}>
              Qty
            </label>
            <div className="d-flex align-items-center gap-2">
              <FontAwesomeIcon
                icon={faMinus}
                size={"sm"}
                color={"black"}
                cursor={"pointer"}
                onClick={() => changeNodeQuantity(quantity - 1)}
              />
              <input
                type="text"
                className="form-control p-0 text-center"
                value={quantity}
                onChange={quantityChangeHandler}
                style={{ maxWidth: 50, maxHeight: 20 }}
              />
              <FontAwesomeIcon
                icon={faPlus}
                size={"sm"}
                color={"black"}
                cursor={"pointer"}
                onClick={() => changeNodeQuantity(quantity + 1)}
              />
            </div>
          </div>
        ) : (
          <FontAwesomeIcon
            icon={faClone}
            size={"lg"}
            color={"black"}
            cursor={"pointer"}
            onClick={() => addActionHandler(node.node_id)}
          />
        )} */}
        {compositionType !== COMPOSITION_OPTIONS.COMPONENT && (
          <FontAwesomeIcon
            icon={faClone}
            size={"lg"}
            color={"black"}
            cursor={"pointer"}
            onClick={() => addActionHandler(node.node_id)}
          />
        )}

        <FontAwesomeIcon
          icon={faPencil}
          size={"lg"}
          color={"black"}
          cursor={"pointer"}
          onClick={() => editActionHandler(compositionType, node)}
        />

          <FontAwesomeIcon
            icon={faTrash}
            size={"lg"}
            color={"black"}
            cursor={"pointer"}
            onClick={() => setShowRemovalModal(true)}
          />
      </div>
    </>
  );
};

export default TreeActionsGroup;
